import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { get_global_db } from "../../../Scripts/initializeFSTORE";


export const searchDiscountCode = async (discount_code) => {
    const db = get_global_db()
    let discountCodeDocument = [];
    let success = null;
    try {
        const collectionRef = collection(db, 'discountCodes');
        const q = query(collectionRef, where('code', '==', discount_code));
        let res = await getDocs(q)
        res.forEach(doc=>{
            discountCodeDocument.push(doc.data())
            success = true
        })
    } catch (error) {
        console.log("Ocurrio un error en 'searchDiscountCode' ")
        console.log(error)
        success = false 
    }

    return {
        success,
        discountCodeData: discountCodeDocument[0]
    }

}